import { PlanDetailsProps } from '@components/pages/Cancel/Confirmation/interfaces';
import { api_show_confirmation_modal_path } from '@routes';

import request from './request';

export const SHOW_CONFIRMATION_MODAL_KEY = 'show_confirmation_modal_key';

export interface ShowConfirmationModalResponse extends PlanDetailsProps {
  showConfirmationModal: boolean;
}

export async function showConfirmationModal(): Promise<ShowConfirmationModalResponse> {
  const resp = await request('get', api_show_confirmation_modal_path());
  return resp;
}
